export default __webpack_public_path__ + "static/media/udentify-big.7a0e5cd0.png";